import React from "react";
import Picker from "react-month-picker";
import "react-month-picker/scss/month-picker.scss";
import "../../assets/scss/global.scss";
import "../../assets/scss/intel.scss";
import MonthBox from "../../shared/country-components/trademo-date-picker/month-box";
import "./month-range-picker.scss";
const pickerLang = {
  months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  from: "From",
  to: "-",
};
export default class MonthRangepickerComponent extends React.Component {
  pickRange = React.createRef(null);
  state = {
    actualFromYear: +this.props.monthObject.actualFromYear,
    actualFromMonth: +this.props.monthObject.actualFromMonth,
    actualToYear: +this.props.monthObject.actualToYear,
    actualToMonth: +this.props.monthObject.actualToMonth,
    rangeValue: JSON.parse(JSON.stringify(this.props.monthObject.rangeValue)),
  };
  // Below Method is used for setting up the formatted text inside the month range picker
  makeText = (m) => {
    if (m && m.year && m.month) return pickerLang.months[m.month - 1] + "-" + m.year;
    return "?";
  };
  // End of the above code
  // Below Method is used for handle month change functionality
  handleMonthChange = (year, month, index) => {
    let value = { ...this.state.rangeValue };
    if (index === 0 && year && month) {
      value.from.year = year;
      value.from.month = month;
    } else if (index === 1 && year && month) {
      value.to.year = year;
      value.to.month = month;
    }
    this.setState({ rangeValue: { ...value } });
  };
  // End of the above
  // Below Method is used for the Month Dismiss Functionality
  handleMonthDissmis = (value) => {
    if (!!value && !!value.from && value.from !== "" && !!value.to && value.to !== "") {
      this.setState({
        rangeValue: { ...value },
      });
      setTimeout(() => {
        this.monthBoxValue(value);
      }, 100);
    } else {
      const oldStartDate = new Date(this.props.monthObject.rangeValue.from.year + "-" + this.props.monthObject.rangeValue.from.month + "-01");
      const oldEndDate = new Date(this.props.monthObject.rangeValue.to.year + "-" + this.props.monthObject.rangeValue.to.month + "-01");
      this.setState({
        actualFromDate: oldStartDate,
        actualToDate: oldEndDate,
      });
    }
  };
  // End of the above code
  // Below code is used for the Open the month range picker
  handleClickMonthBox = () => {
    this.pickRange.current.show();
  };
  // End of the above code
  // Below code is for Month Box Value
  monthBoxValue = () => {
    if (!!this.state && !!this.state.rangeValue && !!this.state.rangeValue.from && this.state.rangeValue.from !== "" && !!this.state.rangeValue.to && this.state.rangeValue.to !== "") {
      return this.makeText(this.state.rangeValue.from) + " - " + this.makeText(this.state.rangeValue.to);
    } else {
      return "";
    }
  };
  // End of the above code
  //below code is to append custom apply and cancel button
  appendApplyButton = () => {
    let grandParent = document.getElementsByClassName("month-range-picker-style"); // getting grand parent div
    let parent = null;
    if (grandParent[1]) {
      parent = grandParent[1].getElementsByClassName("rmp-popup"); //getting parent from grand parent
    }
    if (parent && parent[0]) {
      //creating new horizonal line
      const newLine = document.createElement("hr");
      newLine.className = "monthpicker-horizontal-line";
      parent[0].appendChild(newLine);
      //creating new div
      const newDiv = document.createElement("div");
      newDiv.className = "text-right";
      //creating cancel button
      const cancelBtn = document.createElement("button");
      cancelBtn.className = "cancelBtn btn btn-sm btn-outline-secondary trademo-outline-btn py-2 mr-2 mt-1";
      let cancelButtonText = document.createTextNode("Cancel");
      cancelBtn.appendChild(cancelButtonText);
      newDiv.appendChild(cancelBtn);
      cancelBtn.onclick = this.handleCancel;
      //creating apply button
      const applyBtn = document.createElement("button");
      applyBtn.className = "applyBtn btn btn-sm btn-primary trademo-new-btn mr-2 mt-1";
      let applyButtonText = document.createTextNode("Apply");
      applyBtn.appendChild(applyButtonText);
      newDiv.appendChild(applyBtn);
      applyBtn.onclick = this.handleApply;
      //append apply and cancel button to parent div
      parent[0].appendChild(newDiv);
    }
  };
  // End of the above code
  // below code is for handel apply
  handleApply = () => {
    this.props.monthRangePickerDismiss(this.state.rangeValue);
    this.handleCancel();
  };
  // End of the above code
  // below code is for handel cancel button click
  handleCancel = () => {
    this.setState({ rangeValue: null });
    setTimeout(() => {
      this.setState({ rangeValue: JSON.parse(JSON.stringify(this.props.monthObject.rangeValue)) });
      this.appendApplyButton();
    });
  };
  // End of the above code
  // Below code is used for Mounting the component
  componentDidMount() {
    this.appendApplyButton();
  }
  // End of the above code
  render() {
    return (
      <>
        {!!this.state && !!this.state.rangeValue && !!this.state.rangeValue.from && this.state.rangeValue.from !== "" && !!this.state.rangeValue.to && this.state.rangeValue.to !== "" ? (
          <div className="form-group mb-0">
            <Picker
              ref={!!this && !!this.pickRange && this.pickRange !== "" ? this.pickRange : null}
              years={{
                min: {
                  year: +this.state.actualFromYear,
                  month: +this.state.actualFromMonth,
                },
                max: {
                  year: +this.state.actualToYear,
                  month: +this.state.actualToMonth,
                },
              }}
              popperPlacement="right-end"
              value={this.state.rangeValue}
              lang={pickerLang.months}
              onChange={(year, month, index) => this.handleMonthChange(year, month, index)}
              onDismiss={(value) => this.handleMonthDissmis(value)}
              theme="light"
              className="month-range-picker-style m-0">
              <MonthBox value={this.monthBoxValue(this.state.rangeValue)} onClick={this.handleClickMonthBox} />
            </Picker>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}
